export default (title, value=null) => {
  console.log(`%c[${Date.now()}:YES::AccessEnabler:${title}]`, 'color: #FFFF00;');
  if(value !== null) {
    console.log(`%cYES >>>---> ${value}`, 'color: #c4df7d;');
  }
};
